var _path, _path2, _circle, _g, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDocUpload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 67,
  height: 75,
  fill: "none",
  viewBox: "0 0 67 75"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#00619E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M26.168 57.826H2.167a1 1 0 0 1-.999-1v-54a1 1 0 0 1 1-1h36.586a1 1 0 0 1 .707.293l9.414 9.414a.98.98 0 0 1 .293.7v21.593"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#00619E",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M39.168 2.826v8c0 .553.445 1 .997 1h8.003"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 49,
  cy: 57,
  r: 17,
  stroke: "#00AED9",
  strokeWidth: 2
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#00AED9",
  fillRule: "evenodd",
  d: "M51.538 54.58a1 1 0 1 0 1.47-1.357l-3.273-3.546a1 1 0 0 0-1.47 0l-3.273 3.546a1 1 0 0 0 1.47 1.356L48 52.913v6.443a1 1 0 0 0 2 0v-6.443zM42 58a1 1 0 1 0-2 0v4.876c0 1.173.951 2.125 2.125 2.125h13.75A2.125 2.125 0 0 0 58 62.876V58a1 1 0 1 0-2 0v4.875a.125.125 0 0 1-.125.125h-13.75a.125.125 0 0 1-.125-.125z",
  clipRule: "evenodd"
}))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#00619E",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M11.168 19.826h28M11.168 35.826h20M11.168 43.826h12M11.168 27.826h28"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M40 49h18v16H40z"
})))));
export default SvgDocUpload;